import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import Alert from "@mui/material/Alert";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { postDisable2FAWarning } from "redux/handlers/userHandler";

import { get2FA } from "redux/selectors/userSelector";

import { useAppDispatch } from "hooks/reduxHook";

const TwoFANotActive = (): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const faOn = useSelector(get2FA);

 const [accept, setAccept] = useState<boolean>(false);

 const handleAccept = async () => {
  await dispatch(postDisable2FAWarning());
 };

 return faOn ? (
  <></>
 ) : (
  <Alert severity="warning" color="error" variant="filled">
   <Stack textAlign="left">
    <Typography fontWeight="bold" variant="subtitle2">
     <FormattedMessage id="app.2faOfflineTitle" />
    </Typography>
    <Typography variant="caption">
     <FormattedMessage id="app.2faOffline" />
    </Typography>
    <FormControlLabel
     control={
      <Checkbox
       sx={{
        color: "white",
        "&.Mui-checked": {
         color: "white"
        }
       }}
       checked={accept}
       onChange={(e, checked) => {
        setAccept(checked);
        handleAccept();
       }}
      />
     }
     label={intl.formatMessage({ id: "app.2faOfflineAccept" })}
    />
   </Stack>
  </Alert>
 );
};

export default TwoFANotActive;
